<template>
  <a-modal
    :visible="visible"
    width="702px"
    :mask-closable="false"
    :title="title"
    :confirm-loading="btnIsLoading"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #name>
        <a-input
          v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入广告名称',
                },
              ],
            },
          ]"
          placeholder="请输入广告名称"
        />
      </template>
      <template #remark>
        <a-textarea
          v-decorator="[
            'remark',
            { rules: [{ required: true, message: '请输入' }] },
          ]"
          rows="3"
          placeholder="请输入"
          maxlength="150"
        />
      </template>
    </basic-form>
  </a-modal>
</template>
<script>
import { formData } from '../data/index';
export default {
  props: ['visible', 'title', 'btnIsLoading'],
  data() {
    return {
      formData,
    };
  },
  async mounted() {
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
}
</style>
